export const SET_MANDAYS_DATA = "SET_INDUSTRY_DATA";
export const MANDAYS_FETCHING_INIT = "MANDAYS_FETCHING_INIT";
export const MANDAYS_FETCHING_COMPLETED = "MANDAYS_FETCHING_COMPLETED";
